import React from 'react';

import {Button} from '../../../components/Button';
import {GoogleIcon} from '../../../icons';
import {useGoogleLogin} from '../../../lib/auth/google/useGoogleLogin';
import {appLog} from '../../../lib/utils/Logger';
import {authStyles} from '../styles';
import {SocialAuthButtonProps} from './AppleSignIn';

export const GoogleSignIn: React.FC<SocialAuthButtonProps> = ({
  screen = 'login',
  style,
  onSubmit,
  ...props
}) => {
  const initiate = useGoogleLogin({state: screen});

  const onPress = React.useCallback(async () => {
    try {
      const code = await initiate();

      onSubmit(code);
    } catch (error) {
      appLog.error(`Failed to login with Google.`, {error});
    }
  }, [initiate, onSubmit]);

  return (
    <Button {...{onPress}} style={[authStyles.socialButton, style]} {...props}>
      <GoogleIcon />
    </Button>
  );
};
